import { createSelector } from '@ngrx/store';
import { GlobalState } from '../../../../store/global';

export const state = (state: GlobalState) => state.locations.map;

export const selectAreMarkersMinimized = createSelector(
    state, (state) => state.markersMinimized);

export const selectIsCvButtonActive = createSelector(
    state, (state) => state.cvButtonActive);

export const selectIsStreetViewActive = createSelector(
    state, (state) => state.streetViewActive);

export const selectIsStreetViewClosedByUser = createSelector(
    state, (state) => state.streetViewClosedByUser);

export const selectShowValidationHistory = createSelector(
    state, (state) => state.showValidationHistory);
